import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import React from "react";
import { TEMPLATE_ID_AUTH } from "../../config/templates";
import { styled } from "@mui/material/styles";
import { currentClient, currentClientName } from "../../config/clients";

export const Container = styled(Paper)(({ theme }) => ({
	borderRadius: theme.spacing(1),
	boxShadow: theme.shadows[5]
}));

const AuthContainer = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.common.white,
	boxShadow: "0 5px 15px rgba(0,0,0,.5)",
	color: theme.palette.text.primary,
	margin: "50px auto",
	width: 350
}));

const AuthContent = styled(Box)(({ theme }) => ({
	padding: "30px 16px 25px"
}));

const AuthHeader = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	backgroundImage: `url('${process.env.PUBLIC_URL}/assets/logos/${currentClient}.svg')`,
	backgroundRepeat: "no-repeat",
	backgroundPosition: "center center",
	backgroundSize: "162px 68px",
	color: theme.palette.primary.contrastText,
	height: "120px"
}));

const Main = styled(Box)(({ theme }) => ({
	backgroundColor: "#909090",
	minHeight: "100vh"
}));

const AuthTemplate = props => {

	const { children, contentStyles = {} } = props;

	return (
		<React.Fragment>
			<Main component="main" data-template-id={TEMPLATE_ID_AUTH} id="main">
				<AuthContainer>
					<AuthHeader>
						<span className="a11y-hidden">{currentClientName}</span>
					</AuthHeader>
					<AuthContent sx={contentStyles}>
						{children}
					</AuthContent>
				</AuthContainer>
			</Main>
		</React.Fragment>
	);
};

export default AuthTemplate;